import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import WorkersCompensationRatesWrapper from "@components/layouts/workersCompensationRatesWrapper";
import Header from "@components/shared/header";
import colors from "@styles/variables/workersCompensationRatesVariables.module.scss";
import WorkersCompensationRatesLogo from "@components/workerscompensationrates/logo";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <WorkersCompensationRatesWrapper>
            <Header
                textColor={colors.headerPhoneColor}
                slogan="the best workers compensation rates"
            >
                <WorkersCompensationRatesLogo />
            </Header>
            <div className="max-w-7xl mx-auto">
                <PrivacyPolicy
                    domain="WorkersCompensationRates.com"
                    category="Workers Compensation"
                />
            </div>
        </WorkersCompensationRatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
